import { useTranslation } from "react-i18next";
import React from "react";
import { Row, Col } from "react-bootstrap";
import Input from "@components/forms/Input";
import DateInput from "@components/forms/DateInput";
import ISelect from "@components/forms/ISelect";
import { Plus, Search } from "lucide-react";
import { Config } from "@config/config";
import { useModal } from "@components/ModalContext";
import NewInvoice from "../components/NewInvoice";
function InvoiceForm(props) {
  const { t } = useTranslation();
  const config = new Config(t);
  const { openModal, setFullscreen, setTitle, setModalBodyClass } = useModal();
  const newInvoice = async (item) => {
    setFullscreen(true);
    setTitle(t("new_invoice"));
    setModalBodyClass("modal-body-0");
    openModal(<NewInvoice loadData={props.loadData} />);
  };
  return (
  
      <Row className="my-3 align-items-end">
        <Col xl="3" className="my-3">
          <Input
            placeholder={t("ho_act_facturation_num")}
            type="text"
            value={props.invoiceNumber}
            onChange={props.handleInvoiceNumber}
            height={50}
          />
        </Col>
        <Col xl="3" className="my-3">
          <DateInput
            leftLabel={t("from")}
            rightLabel={t("to")}
            onDateChange={props.onChangeDate}
            dateFrom={props.dateFrom}
            dateTo={props.dateTo}
          />
        </Col>
        <Col xl="2" className="my-3">
          <ISelect
            id="status"
            name="status"
            label={t("status")}
            value={props.selectedStatus}
            handleChange={props.setSelectedStatus}
            data={config.paymentOptions()}
          />
        </Col>
        <Col xl="2" className="my-3">
          <button
            className="btn-custom-outline w-100 "
            onClick={() => props.loadData(0)} style={{height:"50px"}}
          >
            <Search size={25} strokeWidth={1.2} /> {t("search")}
          </button>
        </Col>
        <Col xl="2" className="my-3">
          <button className="btn-custom w-100 " onClick={newInvoice} style={{height:"50px"}}>
            <Plus size={25} strokeWidth={1.2} />
            <span className="me-1 ">{t("new_invoice")}</span>
          </button>
        </Col>
      </Row>
 
  );
}
export default InvoiceForm;
